module.exports = __webpack_public_path__ + "static/img/9.e30082b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/9.png
// module id = SxJ9
// module chunks = 0